import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import {
  ThemeProvider,
  unstable_createMuiStrictModeTheme as createMuiTheme,
} from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/core/styles";

import NavBar from "components/layouts/NavBar";
// import Drawer from './components/layouts/Drawer';

import "../src/index.css";
import { Provider as ReduxProvider } from "react-redux";
import store from "./store/store";
import Loader from "./components/UI/Loader";

import ProtectedRoute from "./components/common/ProtectedRoute";
import { routes } from "./routes";

import purple from "@material-ui/core/colors/purple";
import AddPickupLocation from "screens/signup/AddPickupLocation";
// footer
import Footer from "components/layouts/Footer";

import Login from "components/layouts/Login";
import NotFound from "components/layouts/PageNotFound";
import PermissionDenied from "components/layouts/PermissionDenied";
import SignUp from "components/layouts/SignUp";
import ForgotPassword from "components/layouts/ForgotPassword";
import Auth from "components/common/Auth";
import DateTimePicker from "./screens/pickup/Pickup";
import PlaceOrder from "screens/placeOrder/PlaceOrder";
import Delivery from "screens/delivery/Delivery";
import Order from "./screens/order/Order";
import ConfirmOrder from "./screens/confirmOrder/ConfirmOrder";
import Flow from "./screens/flow/Flow";
import SpecialCare from "./screens/specialCare/SpecialCare";
import Complete from "screens/complete/Complete";
import SetPassword from "./components/layouts/SetPassword";
import OrderTracking from "./components/orderTrack/orderTracking";

import OrderCardAdded from "./screens/placeOrder/OrderCardAdded";
import "./utils/styles/Calendar.css"
import * as Sentry from "@sentry/react";
import About from "components/layouts/About";
import Services from "components/layouts/Sevices";
import FAQ from "components/layouts/FAQ";
import ContactUs from "components/layouts/ContactUs";
import TermsAndConditions from "components/layouts/TermsAndConditionsPage";


const lightTheme = createMuiTheme({
  palette: {
    type: "light",
    secondary: {
      main: purple[500],
    },
  },
  overrides: {
    MuiFormLabel: {
      asterisk: {
        color: "#db3131",
        "&$error": {
          color: "#db3131",
        },
      },
    },
  },
});

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
  },
  self: {
    backgroundColor: "blue",
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
}));

function App(props) {
  const classes = useStyles();

  return (
    <ReduxProvider store={store}>
      <ThemeProvider theme={lightTheme}>
        <div className={classes.root}>
          <NavBar {...props}> </NavBar>

          <Suspense
            fallback={
              <div>
                <Loader />
              </div>
            }
          >
            <Auth>
              <Routes>
                <Route path="/" element={<Login />} />
                <Route
                  path="/permission-denied"
                  element={<PermissionDenied />}
                />

                {routes.map(({ element, path, name }) => (
                  <Route
                    key={name}
                    path={path}
                    element={<ProtectedRoute element={element} />}
                  />
                ))}
                <Route component={NotFound}></Route>
                <Route path="/signup" element={<SignUp />} />
                <Route path="/about" element={<About />} />
                <Route path="/services" element={<Services />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/contact-us" element={<ContactUs />} />
                <Route path="/terms-and-conditions" element={<TermsAndConditions />} />

                <Route path="/track/:orderId" element={<OrderTracking />} /> 

                <Route path="/pickup" element={<DateTimePicker />} />
                <Route path="/delivery" element={<Delivery />} />
                <Route path="/specialCare" element={<SpecialCare />} />
                <Route path="/checkout" element={<PlaceOrder />} />
                <Route path="/order" element={<Order />} />
                <Route path="/complete" element={<Complete />} />
                <Route
                  path="/order/payments/setup-complete"
                  element={<OrderCardAdded />}
                />
                <Route path="/confirmOrder" element={<ConfirmOrder />} />
                <Route path="/orderFlow" element={<Flow />} />
                <Route path="/passwordhelp" element={<ForgotPassword />} />
                <Route
                  exact
                  path="/signup/addlocation"
                  element={<AddPickupLocation />}
                />
                <Route path="/set-password/:email/:verifyTokens" element={<SetPassword />} />
              </Routes>
            </Auth>
          </Suspense>
          <Footer />
        </div>
      </ThemeProvider>
    </ReduxProvider>
  );
}

export default Sentry.withProfiler(App);
// point to dev
